import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TablePagination from "@material-ui/core/TablePagination";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import MainWrapper from "../wrappers/MainWrapper";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { reduxForm, Field, reset } from "redux-form";
import validateEmail from "../../utils/validateEmail";
import {
  checkUserRole,
  fetchGroupList,
  fetchReportList,
  fetchReportListCSV,
  fetchReportListShape,
} from "../../actions";
import Snackbar from "@material-ui/core/Snackbar";
import NotificationSnackBar from "../../utils/NotificationSnackBar";
import PlusCircleIcon from "@material-ui/icons/AddCircle";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import SearchIcon from "@material-ui/icons/Search";
import EnhancedTableToolbar from "../../utils/EnhancedTableToolbar";
import { userListStyle } from "../../utils/Style";
import ReportListTable from "../../utils/MainTable/ReportListTable";
import { CSVLink, CSVDownload } from "react-csv";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

function getModalStyle() {
  return {
    top: `${50}%`,
    left: `${50}%`,
    transform: `translate(-${50}%, -${50}%)`,
  };
}

const required_fields = [
  { name: "description", label: "description" },
  { name: "expiryDay", label: "expiry day" },
  { name: "type", label: "type" },
];

const WAIT_INTERVAL = 1000;

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  loadingHeight: {
    height: "100%",
    position: "fixed",
    backgroundColor: "rgba(220,220,220,0.3)",
    top: "0",
    right: "0",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: 350,
  },
  button: {
    width: 300,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 10,
  },
  alreadySignIn: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: "auto",
    marginRight: "auto",
  },
  success: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: "auto",
    marginRight: "auto",
    color: "green",
  },
});
class ReportList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selected: [],
      open: false,
      isSwitchSnackbarOn: false,
      page: 0,
      rowsPerPage: 5,
      offset: 0,
      dateFrom: "",
      dateTo: "",
      key: "",
      loading: false,
      contextChanged: true,
      userRoles: {
        userRoles: [],
        error: null,
      },
      csv: {
        content: "",
      },
      shape: {
        content: "",
      },
      fire_status: "",
      report_status: "",
      data_source: "",
      enableCsv: false,
      enableShape: false,
      reportListRes: null,
      consent:null,
      type: "",
      grouplist: [],
    };
  }

  componentDidMount() {
    this.props.checkUserRole();
    this.props.fetchGroupList();
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;
    //    this.props.checkfilestatus(today,today );
    this.setState({ loading: false, dateFrom: today, dateTo: today });
  }

  static getDerivedStateFromProps(props, state) {
    let update = {};
    console.log("report prop", props);
    console.log("report state", state);
    if (props.obtainkey !== state.key) {
      //     update.loading= false;
    }

    if (
      props.reportList !== state.reportListRes &&
      props.obtainkey !== state.key
    ) {
      update.reportListRes = props.reportList;
      update.isSnackbarError = props.reportList.isSnackbarError;
      update.isSwitchSnackbarOn = props.reportList.isSwitchSnackbarOn;
      update.snackbarErrorMessage = props.reportList.ErrorMessage;
      update.loading = false;
    }

    if (props.reportList.csv !== state.csv) {
      update.csv = props.reportList.csv;
      if (
        props.reportList.csv.content !== "" &&
        props.reportList.csv.content !== undefined
      )
        update.enableCsv = true;
    }

    if (props.reportList.groups !== state.groups) {
      update.grouplist = props.reportList.groups;
      
    }

    if (
      props.reportList.shape !== state.shape &&
      props.reportList.shape !== undefined
    ) {
      update.shape = props.reportList.shape;
      if (
        props.reportList.shape.content !== "" &&
        props.reportList.shape.content !== undefined
      )
        update.enableShape = true;
    }
    if (props.userRoles.success !== null) {
      if (!props.userRoles.success) {
        localStorage.clear();
        props.history.push("/signIn");
      }
      if (
        props.userRoles.userRoles.length !== state.userRoles.userRoles.length
      ) {
        if (props.userRoles.userRoles.length === 0) {
          localStorage.clear();
          props.history.push("/signIn");
        }
      }
    } else {
      localStorage.clear();
      props.history.push("/signIn");
    }

    return update;
  }

  updateSnackbarStatus = (snackbarObject) => {
    this.setState({
      isSnackbarError: snackbarObject.isSnackbarError,
      isSwitchSnackbarOn: snackbarObject.isSwitchSnackbarOn,
      snackbarErrorMessage: snackbarObject.ErrorMessage,
    });
  };

  updateSnackbarStatusFalse = () => {
    if (this.state.isSwitchSnackbarOn) {
      this.setState({ isSwitchSnackbarOn: false });
    }
  };

  /*
    _handleSubmit = values => {
        this.handleModalClose();
        Object.assign(values, { id: this.state.id }, { keyword: '' }, { offset: this.setNewOffset(this.state.rowsPerPage, this.state.page) }, { limit: this.state.rowsPerPage });
        this.props.registerPackage(values, this.props.history);
    };
    handleModalOpen = (id, username) => {
        this.updateSnackbarStatusFalse();
        this.setState({
            id: id,
            username: username,
            open: true,
        });
    };

    handleModalClose = () => {
        this.setState({ open: false });
        this.props.reset();
    }; 
    handleActive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage);
    };

    handleInactive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoinactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage );
    };

    handleSelectAllClick = (event, checked) => {
        this.updateSnackbarStatusFalse();
        if (checked) {
            this.setState({ selected: this.state.users.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        this.updateSnackbarStatusFalse();
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(this.state.rowsPerPage, page), this.state.rowsPerPage);
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(event.target.value, this.state.page), event.target.value);
        this.setState({ rowsPerPage: event.target.value });
    };

    setNewOffset = (rowPerPage, page) => {
        return rowPerPage * page;
    }
*/

  handleChange = (name) => (event) => {
    this.updateSnackbarStatusFalse();
    this.setState({ [name]: event.target.value, contextChanged: true });
  };

  handleCSVSearch = (event) => {
    this.setState({ loading: true });
    this.updateSnackbarStatusFalse();
    var search = {
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
      consent: this.state.consent == "true"? true : this.state.consent == null ? null : false,
      isprotected: false,
      ispeat: false,
      country: "",
      fire_status: this.state.fire_status,
      report_status: this.state.report_status,
      source: this.state.type,
      groupName: "",
    };
    // this.setState({ searchVal: event.target.value })
    this.props.fetchReportListCSV(search); 
  };

  handleShapefileSearch = (event) => {
    this.setState({ loading: true });
    this.updateSnackbarStatusFalse();
    var search = {
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
      consent: this.state.consent == "true"? true : this.state.consent == null ? null : false,
      isprotected: false,
      ispeat: false,
      country: "",
      fire_status: this.state.fire_status,
      report_status: this.state.report_status,
      source: this.state.type,
      groupName: "",
    };
    // this.setState({ searchVal: event.target.value })
    this.props.fetchReportListShape(search);
  };

  handleSearch = (event) => {
    this.setState({ loading: true });
    this.updateSnackbarStatusFalse();
    var search = {
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
      consent: this.state.consent == "true"? true : this.state.consent == null ? null : false,
      isprotected: false,
      ispeat: false,
      country: "",
      fire_status: this.state.fire_status,
      report_status: this.state.report_status,
      source: this.state.type,
      groupName: "",
    };
    // this.setState({ searchVal: event.target.value })
    this.props.fetchReportList(search);
  };

  handleDate = (name) => (event) => {
    let that = this;
    let e = event;
    console.log(this.state[name]);
    if (e.target.value !== this.state[name]) {
      that.setState({ [name]: e.target.value, contextChanged: true });
    }
    /*  clearTimeout(this.timer);
        this.timer = setTimeout(function () {
            
           
         
        }, WAIT_INTERVAL);
        */
  };

  render() {
    const { classes } = this.props;
    const {
      users,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      offset,
      isSwitchSnackbarOn,
      isSnackbarError,
      enableCsv,
      loading,
      report_status,
      enableShape,
      grouplist,
      consent
    } = this.state;
    return (
      <MainWrapper
        history={this.props.history}
        isDisplayOn="none"
        userRoles={this.props.userRoles}
      >
        <Paper className={classes.root}>
          <EnhancedTableToolbar tableName="Reports" numSelected={0} />
          <div className={classes.search}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <SearchIcon />
              </Grid>
              <Grid item>
                <TextField
                  id="dateFrom"
                  label="Acquisition Date from"
                  type="date"
                  defaultValue={this.state.dateFrom}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={this.handleDate("dateFrom")}
                />
              </Grid>
              <Grid item>
                <TextField
                  id="dateTo"
                  label="Acquisition Date to"
                  type="date"
                  defaultValue={this.state.dateTo}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={this.handleDate("dateTo")}
                />
              </Grid>

              <Grid item>
                <FormControl
                  className={classes.formControl}
                  style={{ width: 150 }}
                >
                  <InputLabel htmlFor="report_status">Report Status</InputLabel>
                  <Select
                    value={report_status}
                    onChange={this.handleChange("report_status")}
                    name="report_status"
                    inputProps={{
                      id: "report_status",
                    }}
                    className={classes.selectEmpty}
                  >
                    <MenuItem value="NEW">
                      <em>NEW</em>
                    </MenuItem>
                    <MenuItem value="NOTIFIED 1">NOTIFIED 1</MenuItem>
                    <MenuItem value="NOTIFIED 2">NOTIFIED 2</MenuItem>
                    <MenuItem value="NOTIFIED 3">NOTIFIED 3</MenuItem>
                    <MenuItem value="UPLOADED">UPLOADED</MenuItem>
                    <MenuItem value="UNATTENDED">UNATTENDED</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl
                  className={classes.formControl}
                  style={{ width: 150 }}
                >
                  <InputLabel htmlFor="status">Fire status</InputLabel>
                  <Select
                    value={this.state.fire_status}
                    onChange={this.handleChange("fire_status")}
                    name="fire_status"
                    inputProps={{
                      id: "fire_status",
                    }}
                    className={classes.selectEmpty}
                  >
                    <MenuItem value="INSIDE">
                      <em>INSIDE</em>
                    </MenuItem>
                    <MenuItem value="OUTSIDE">OUTSIDE</MenuItem>
                    <MenuItem value="WITHIN AND OUTSIDE">
                      WITHIN AND OUTSIDE
                    </MenuItem>
                    <MenuItem value="NO FIRE">NO FIRE</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item style={{ padding: "10px" }}>
                <FormControl
                  className={classes.formControl}
                  style={{ width: 150 }}
                >
                  <InputLabel htmlFor="datatype">Parent List</InputLabel>
                  <Select
                    value={this.state.type}
                    onChange={this.handleChange("type")}
                    name="type"
                    inputProps={{
                      id: "datatype",
                    }}
                    className={classes.selectEmpty}
                  >
                    {grouplist.map(x=> (
                       <MenuItem value={x.id}>
                       <em>{x.group_name}</em>
                     </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText></FormHelperText>
                </FormControl>
              </Grid>

              <Grid item>
                <FormControl
                  className={classes.formControl}
                  style={{ width: 100 }}
                >
                  <InputLabel htmlFor="consent">Consent</InputLabel>
                  <Select
                    value={this.state.consent}
                    onChange={this.handleChange("consent")}
                    name="consent"
                    inputProps={{
                      id: "consent",
                    }}
                    className={classes.selectEmpty}
                  >
                    <MenuItem value="">
                      <em></em>
                    </MenuItem>
                    <MenuItem value="true">Yes</MenuItem>
                    <MenuItem value="false">
                      No
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={(e) => this.handleSearch(e)}
                >
                  Search
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={(e) => this.handleCSVSearch(e)}
                >
                  Activate CSV
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={(e) => this.handleShapefileSearch(e)}
                >
                  Activate Shapefile
                </Button>
              </Grid>
              <Grid item>
                {enableCsv ? (
                  <CSVLink
                    data={this.state.csv.content}
                    filename={"reportlist.csv"}
                    className="btn btn-primary"
                    target="_blank"
                  >
                    Download CSV
                  </CSVLink>
                ) : null}
              </Grid>
              <Grid item>
                {enableShape ? (
                  <a
                    href={
                      "data:application/zip;base64," + this.state.shape.content
                    }
                    className="btn btn-primary"
                    target="_blank"
                  >
                    Download Shapefile
                  </a>
                ) : null}
              </Grid>
            </Grid>

            <Grid container spacing={8} alignItems="flex-end">
              <Grid item></Grid>
            </Grid>
          </div>
          <div className={classes.tableWrapper}>
            <ReportListTable
              data={
                this.state.reportListRes !== null
                  ? this.state.reportListRes.results
                  : []
              }
            />
          </div>
          <NotificationSnackBar
            isSwitchSnackbarOn={this.state.isSwitchSnackbarOn}
            isSnackbarError={this.state.isSnackbarError}
            snackbarErrorMessage={this.state.snackbarErrorMessage}
          />
        </Paper>
        {loading ? (
          <Grid container className={classes.root}>
            <Grid item xs={12}>
              <Grid
                container
                className={classes.loadingHeight}
                justify="center"
                alignItems="center"
              >
                <CircularProgress color="primary" size={70} thickness={7} />
              </Grid>
            </Grid>
          </Grid>
        ) : null}
      </MainWrapper>
    );
  }
}

ReportList.propTypes = {
  classes: PropTypes.object.isRequired,
};

function validate(values) {
  const errors = {};

  return errors;
}

let SignInWithStyles = withStyles(styles)(ReportList);

SignInWithStyles = reduxForm({
  form: "reportListform",
})(SignInWithStyles);

//    getNotExpiredPackages={this.props.notexpiredpackagesResult}>

const mapStateToProps = ({ reportList, userRoles, concessionFormReturn }) => {
  return {
    reportList: reportList,
    userRoles: userRoles,
    reports: concessionFormReturn.status,
    loading: reportList.loading,
    obtainkey: reportList.key,
  };
};

export default connect(mapStateToProps, {
  checkUserRole,
  fetchGroupList,
  fetchReportList,
  fetchReportListCSV,
  fetchReportListShape,
})(SignInWithStyles);



// WEBPACK FOOTER //
// ./src/components/tabs/ReportList.js
/*

                    <MenuItem value="MODIS">
                      <em>MODIS</em>
                    </MenuItem>
                    <MenuItem value="VIIRS">VIIRS</MenuItem>
                    <MenuItem value="VIIRS_NOAA">NOAA</MenuItem>*/